import "./ViewModeOptions.css";

import { ViewMode } from "../../models";

interface ViewModeOptionsProps {
  viewMode: ViewMode;
  onChangeViewMode: (viewMode: ViewMode) => void;
}

const OPTIONS: { key: ViewMode; label: string }[] = [
  { key: ViewMode.Months1, label: "1m" },
  { key: ViewMode.Months3, label: "3m" },
  { key: ViewMode.Months6, label: "6m" },
  { key: ViewMode.Years1, label: "1y" },
  { key: ViewMode.Years2, label: "2y" },
];

export const ViewModeOptions = ({ viewMode, onChangeViewMode }: ViewModeOptionsProps): JSX.Element => {
  return (
    <div className="PortfolioRoadmapViewMode">
      {OPTIONS.map((option) => (
        <button
          key={option.key}
          type="button"
          className={`ViewModeButton ${viewMode === option.key ? "Active" : ""}`}
          onClick={() => onChangeViewMode(option.key)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};
